import React, { useEffect } from "react";
import Banner from "../components/markets/Banner";
import FiveMarkets from "../components/markets/FiveMarkets";
import Features from "../components/markets/Features";
import TradeDirection from "../components/markets/TradeDirection";
import MarketHours from "../components/markets/MarketHours";
import ThreeMoves from "../components/markets/ThreeMoves";
import Faq from "../components/markets/Faq";
import CTASection from "../components/markets/CTASection";

function Markets() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <FiveMarkets />
      <Features />
      <TradeDirection />
      <MarketHours />
      <ThreeMoves />
      <Faq />
      <CTASection />
    </div>
  );
}

export default Markets;
